module.exports = __webpack_public_path__ + "92060ec9c4855f53fac633eb7a353ccd.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/Sistel.png
// module id = 634
// module chunks = 0